import { joiResolver } from "@hookform/resolvers/joi";
import { FormGroupLabelUI } from "components/FormGroupLabel";
import { RhfInput } from "components/rhfs/RhfInput";
import { Button } from "components/ui/Button";
import type { ResetPassWordInput } from "hooks/authProvider/authProvider";
import Joi from "joi";
import type React from "react";
import { FormProvider, type SubmitHandler, useForm } from "react-hook-form";

type ResetPassWordInputUIProps = {
  onResetPassWord: SubmitHandler<ResetPassWordInput>;
};

export const ResetPassWordInputUI: React.VFC<ResetPassWordInputUIProps> = ({
  onResetPassWord,
}) => {
  const schema = Joi.object({
    email: Joi.string().required().messages({
      "string.empty": "メールアドレスは必須項目です",
    }),
  });
  const methods = useForm<ResetPassWordInput>({
    resolver: joiResolver(schema),
  });
  return (
    <div className="w-5/6 mx-auto">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onResetPassWord)}>
          <FormGroupLabelUI>メールアドレス</FormGroupLabelUI>
          <RhfInput
            name="email"
            placeholder="メールアドレス"
            data-testid="reset-pass-word-input-email"
          />

          <div className="flex justify-center mt-12">
            <Button
              size="lg"
              type="submit"
              width="full"
              data-testid="reset-pass-word-input-submit"
            >
              パスワードを再設定
            </Button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};
